import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as OktaSignInWidget from '@okta/okta-signin-widget';
import { oktaConfig } from 'utils/okta-config';
class OktaForm extends React.Component {

  componentDidMount() {
    const widget = new OktaSignInWidget({ ...oktaConfig, username: this.props.username });
    widget.renderEl(
      { el: '#osw-container' },
      () => { },
      (err) => {
        throw err;
      },
    );
  }

  componentWillUnmount() {
    if (this.widget) this.widget.remove();
  }


  render() {
    return (
      <span>
        <Modal.Body >
          <div id="okta-box">
            <div id="osw-container" />
            <div id="okta-footer">Powered by Okta</div>
          </div>
        </Modal.Body>
      </span>
    );
  }
}

OktaForm.propTypes = {
  username: PropTypes.string.isRequired,
};

export default connect(null, null)(OktaForm);



// WEBPACK FOOTER //
// ./src/containers/Login/OktaForm.js